module.exports = __webpack_public_path__ + "img/Financial Resolutions Infographic.fc0b0c60.png";